import { render, staticRenderFns } from "./MenuModal.vue?vue&type=template&id=1f559489&scoped=true"
import script from "./MenuModal.vue?vue&type=script&lang=js"
export * from "./MenuModal.vue?vue&type=script&lang=js"
import style0 from "./MenuModal.vue?vue&type=style&index=0&id=1f559489&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f559489",
  null
  
)

export default component.exports